export default "__VITE_ASSET__BYzSiUGO__"